/*
 *@Author: 王伟东
 *@Date: 2021-06-29 11:48:34
 *@Description: 聊天壳调用matt发消息层
*/

// <script src="https://webrtc.github.io/adapter/adapter-latest.js"></script>
// vue实例
let _vue = {};

// 初始化传递进来的信息
let optionsData = {};

// 本地流
let localStream;

//mediastream 
let mediaStreamTrack;


// 本地视频
let localVideo;
let remoteVideo;


// 本地和远端连接对象
let localPeerConnection;

// 设置约束
const mediaStreamConstraints = {
  video: true,
  audio: true
};

// 设置仅交换视频音频
const offerOptions = {
  offerToReceiveVideo: 1,
  offerToReceiveAudio: 1
};



// 3.端与端建立连接
let peerConnection = "";
let iceCandidate = "";


function handleConnectionChange(event) {
  peerConnection = event.target;
  console.log("ICE state change event: ", event);
  console.log(`localPeerConnection ICE state: ` + `${peerConnection.iceConnectionState}.`);
  if (peerConnection.iceConnectionState.indexOf("disconnected") != -1 || peerConnection.iceConnectionState.indexOf("failed") != -1) { // 失联
    window.transformMqttCallback("disconnected");
  }
}

function handleConnectionSuccess(peerConnection) {
  console.log(`localPeerConnection addIceCandidate 成功`);
}

function handleConnectionFailure(peerConnection, error) {
  console.log(`localPeerConnection addIceCandidate 错误:\n` + `${error.toString()}.`);
}


// 本地视频
function localVideoFn(options) {
  optionsData = options;
  _vue = options._vue;
  // 本地视频和远端视频
  localVideo = options.localVideo;//document.getElementById("localVideo");
  remoteVideo = options.remoteVideo;//document.getElementById("remoteVideo");
  if (!localVideo || !remoteVideo) {
    console.log(`请设置本地视频和远端视频的video标签，他们对应的ref分别是localVideo和remoteVideo`);
    return;
  }
  const servers = {
    "iceServers": [{
      "url": "stun:stun.l.google.com:19302"
    },{
      "url": "stun:stun.xyjsoft.online:3478?transport=udp",
      "username": "xyjsoft",
      "credential": "xyjwork123"
    },{
      "url": "stun:42.192.40.58:3478?transport=udp"
    },{
      "url": "turn:stun.xyjsoft.online:3478?transport=udp",
      "username": "xyjsoft",
      "credential": "xyjwork123"
    },{
      "url": "turn:stun.xyjsoft.online:3478?transport=tcp",
      "username": "xyjsoft",
      "credential": "xyjwork123"
    },{
      "url": "turn:42.192.40.58:3478?transport=udp",
      "username": "ddssingsong",
      "credential": "123456"
    },{
      "url": "turn:42.192.40.58:3478?transport=tcp",
      "username": "ddssingsong",
      "credential": "123456"
    }]
  };
  // 创建本地 RTCPeerConnection 对象
  localPeerConnection = new RTCPeerConnection(servers);
  // 监听返回的 Candidate
  localPeerConnection.addEventListener("icecandidate", handleConnection);
  // 监听 ICE 状态变化
  localPeerConnection.addEventListener("iceconnectionstatechange", handleConnectionChange);

  localPeerConnection.addEventListener("track", gotRemoteMediaStream);

  async function handleConnection(event) {
    // 获取到触发 icecandidate 事件的 RTCPeerConnection 对象
    // 获取到具体的Candidate
    peerConnection = event.target;
    iceCandidate = event.candidate;
    if (!event.candidate) {
      return;
    }

    const ids = event.candidate.sdpMid;
    const labels = event.candidate.sdpMLineIndex;
    
    window.videoChatCallback({
      event: "__ice_candidate",
      userId: optionsData.inviteID,
      inviteID: optionsData.inviteID,
      confirmID: optionsData.confirmID,
      confirmName: optionsData.confirmName,
      data: {
        userId: optionsData.inviteID,
        fromID: optionsData.confirmID,
        id: ids,
        label: labels,
        candidate: iceCandidate
      },
    });
  }

  // 4.显示远端媒体流
  async function gotRemoteMediaStream(event) {
      remoteVideo.srcObject = event.streams[0];
      console.log("remote 开始接受远端流");
  }


  // 1.获取本地音视频流
  // 调用 getUserMedia API 获取音视频流
  var support = false; // 是否支持support
  navigator.mediaDevices.getUserMedia(mediaStreamConstraints)
    .then((mediaStream) => {
      support = true;
      mediaStreamTrack = mediaStream.getTracks()[0];
      localVideo.srcObject = mediaStream;
      window.localStream = mediaStream;
      // 注意：新的协议中已经不再推荐使用 addStream 方法来添加媒体流，应使用 addTrack 方法
      // localPeerConnection.addStream(localStream);
      // 遍历本地流的所有轨道
      window.localStream.getTracks().forEach((track) => {
        localPeerConnection.addTrack(track, window.localStream);
      });
    })
    .catch((err) => {
      console.log("getUserMedia 错误", err);
    }).finally(() => {
      if (!support) {
        window.openDialogVisibleHelp();
      }
    });
  // 将音视频流添加到 RTCPeerConnection 对象中
  this.addStream = async function () {

    async function createdOffer(description) {
      // 本地设置描述并将它发送给远端
      // 将 offer 保存到本地
      localPeerConnection.setLocalDescription(description)
        .then(() => {
          console.log("local 设置本地描述信息成功");
          window.videoChatCallback({
            event: "__offer",
            userId: optionsData.confirmID,
            data: {
              userId: optionsData.confirmID,
              fromID: optionsData.inviteID,
              sdp: description
            },
          });
        }).catch((err) => {
          console.log("local 设置本地描述信息错误", err);
        });
    }

    // 2.交换媒体描述信息
    localPeerConnection.createOffer(offerOptions)
      .then(createdOffer).catch((err) => {
        console.log("createdOffer 错误", err);
      });
  }
  // 本地将远端的应答描述设置为远端描述
  // 本地保存 answer
  this.onAnswer = async function (description) {
    localPeerConnection.setRemoteDescription(description.sdp)
      .then((data) => {
        console.log("local 设置远端描述信息成功");
      }).catch((err) => {
        console.log("local 设置远端描述信息错误", err);
      });
  }

  this.addIce = async function (msg) {
    if (msg.messageString.candidate) {
      // 创建 RTCIceCandidate 对象
      const newIceCandidate = new RTCIceCandidate(msg.messageString.candidate);

      // 将本地获得的 Candidate 添加到远端的 RTCPeerConnection 对象中
      localPeerConnection.addIceCandidate(newIceCandidate)
        .then(() => {
          handleConnectionSuccess(peerConnection);
        }).catch((error) => {
          handleConnectionFailure(peerConnection, error);
        });
    }
  }
  async function createdAnswer(description) {
    console.log(`远端应答Answer的sdp:\n${description.sdp}`);
    // 远端设置本地描述并将它发给本地
    // 远端保存 answer
    localPeerConnection.setLocalDescription(description)
      .then(() => {
        console.log("remote 设置本地描述信息成功");
        window.videoChatCallback({
          event: "__answer",
          userId: optionsData.confirmID,
          inviteID: optionsData.inviteID,
          data: {
            userId: optionsData.confirmID,
            fromID: optionsData.inviteID,
            sdp: description
          },
        });
      }).catch((err) => {
        console.log("remote 设置本地描述信息错误", err);
      });
  }

  // 设置远端数据描述setRemoteDescription
  this.answer = async function (description) {
    // 远端将 offer 保存
    localPeerConnection.setRemoteDescription(description.sdp)
      .then(() => {
        console.log("remote 设置远端描述信息成功");
      }).catch((err) => {
        console.log("remote 设置远端描述信息错误", err);
      });
    // 远端创建应答 answer
    localPeerConnection.createAnswer()
      .then(createdAnswer)
      .catch((err) => {
        console.log("远端创建应答 answer 错误", err);
      });
  }

  function hangupHandle() {
    // 关闭连接并设置为空
    if (localPeerConnection) {
      localPeerConnection.close();
    }
    localPeerConnection = null;
    if (window.localStream) {
      window.localStream.getTracks().forEach(track => track.stop());
    }
    localVideo.srcObject = null;
    remoteVideo.srcObject = null;
  }

  // 关闭连接
  this.close = hangupHandle;

  // 静音
  this.muted = function(type) {
    if (type) {
      window.localStream.getTracks().forEach(track => track.enabled = true);
    } else {
      window.localStream.getTracks().forEach(track => track.enabled = false);
    }
  }

  return this;
}


export default {
  localVideoFn
}


// WEBPACK FOOTER //
// ./src/components/vueChart/video/webEachChat.js